import dayjs from 'dayjs';

import { POS, FRESH_KDS } from 'constants/integrations';
import { FULL_DATE_12_HOUR_FORMAT } from './dateTime';
import { CUBOH_COMPANY_PREFIX, LOCATION_HOME_PATH } from './path';

export const REPORT_PATHS = [
  '/reports/analytics',
  '/reports/order-history',
  '/reports/order-control',
  '/reports/order-edits',
  '/reports/pos-errors',
  '/reports/items',
  '/reports/modifiers',
  '/reports/order-cancellations',
];
export const HIDE_MERCHANT_PATHS = ['/', '/menu/mapping'];
export const FORCE_SELECT_MERCHANT_PATHS = ['/integrations', '/integrations*', '/menu/upload'];

export const HIDE_MERCHANT_INTEGRATION_TABS = [POS, FRESH_KDS];

// Build regex patterns programmatically
const reportPaths = REPORT_PATHS.map(path => path.replace(/^\//, ''));
const reportTypesPattern = reportPaths.join('|');
const baseReportPath = `/(${reportTypesPattern})`;
const restaurantReportPath = `/restaurant/[\\w-]+/(${reportTypesPattern})`;
const cubohOverviewPath = '/restaurant/cuboh-[\\w-]+/overview';
const locationHomePath = `/restaurant/[\\w-]+/${LOCATION_HOME_PATH}/?`;
const thirdPartyOrdersPath =
  '(/orders/3rd-party-orders|/restaurant/[\\w-]+/orders/3rd-party-orders)';

export const SHOW_TIMEZONE_REGEX = new RegExp(
  `^(${baseReportPath}|${restaurantReportPath}|${cubohOverviewPath}|${locationHomePath}|${thirdPartyOrdersPath}|/?|)$`,
);

export const HIDE_MULTI_LOCATION_SELECT_REGEX = new RegExp(
  '^(' +
    '/restaurant/[\\w-]+/(integrations|orders-control|overview)' +
    '|' +
    // Cuboh-only location home is already scoped to its company by the URL
    `/restaurant/${CUBOH_COMPANY_PREFIX}[\\w-]+/${LOCATION_HOME_PATH}/?` +
    '|' +
    // Matches the 3rd-party-orders paths
    '(/orders/3rd-party-orders|/restaurant/[\\w-]+/orders/3rd-party-orders)' +
    '|' +
    // Matches the company overview path
    '/overview' +
    '|' +
    // Matches the root path
    '/?' +
    ')$',
);

// Start / End Dates
export const START_DAY = dayjs().startOf('day').format(FULL_DATE_12_HOUR_FORMAT);
export const END_DAY = dayjs().endOf('day').format(FULL_DATE_12_HOUR_FORMAT);

export const TIMEZONES = [
  { altName: 'America/New_York', value: 'US/Eastern', label: 'US/EST' },
  { altName: 'America/Chicago', value: 'US/Central', label: 'US/CST' },
  { altName: 'America/Denver', value: 'US/Mountain', label: 'US/MST' },
  { altName: 'America/Los_Angeles', value: 'US/Pacific', label: 'US/PST' },
  { altName: 'America/Anchorage', value: 'US/Alaska', label: 'US/AKST' },
  { altName: 'Pacific/Honolulu', value: 'US/Hawaii', label: 'US/HST' },
  { altName: 'Canada/Mountain', value: 'America/Edmonton', label: 'CA/AB' },
  { altName: 'Canada/Pacific', value: 'America/Vancouver', label: 'CA/BC' },
  { altName: 'Canada/Central', value: 'America/Winnipeg', label: 'CA/MB' },
  // No Canada/* alias: Canada/Yukon is Whitehorse (MST year-round since 2020), not Yellowknife
  { value: 'America/Yellowknife', label: 'CA/NT' },
];

// A blank name must not match CA/NT, which has no altName.
export function findTimezone(companyTimezone) {
  if (!companyTimezone) return undefined;
  return TIMEZONES.find(tz => tz.value === companyTimezone || tz.altName === companyTimezone);
}

export const ALL_LOCATIONS = 'All Locations';
export const ALL_LOCATIONS_OPTION = {
  companyID: ALL_LOCATIONS,
  merchantID: null,
};

export const TIME_FRAME_OPTIONS = [
  { label: 'Today', value: [dayjs().startOf('day'), dayjs().endOf('day')] },
  {
    label: 'Yesterday',
    value: [dayjs().add(-1, 'd').startOf('day'), dayjs().add(-1, 'd').endOf('day')],
  },
  {
    label: 'Last 7 Days',
    value: [dayjs().add(-7, 'd').startOf('day'), dayjs().add(-1, 'd').endOf('day')],
  },
  {
    label: 'Last 14 Days',
    value: [dayjs().add(-14, 'd'), dayjs().add(-1, 'd').endOf('day')],
  },
  {
    label: 'This Month',
    value: [dayjs().startOf('month'), dayjs().endOf('month')],
  },
  {
    label: 'Last Month',
    value: [dayjs().add(-1, 'M').startOf('month'), dayjs().add(-1, 'M').endOf('month')],
  },
];

export const FILTER_TYPES = {
  RADIO: 'radio',
  SELECT: 'select',
  CHECKBOX: 'checkbox',
  CHECKBOX_TREE: 'checkboxTree',
  DATE: 'date',
};
